import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { Subject, Subscription } from 'rxjs';
import { DataService } from 'src/app/services/data.service';

import { ConfirmReservationDialogComponent } from '../dialogs/confirm-reservation-dialog/confirm-reservation-dialog.component';

import { MatSnackBar } from '@angular/material/snack-bar';
import { CustomPopupComponent } from '../dialogs/custom-popup/custom-popup.component';

@Component({
  selector: 'app-send-notifications',
  templateUrl: './send-notifications.component.html',
  styleUrls: ['./send-notifications.component.sass']
})
export class SendNotificationsComponent implements OnInit {
  showPrimarySpinner: boolean = false;
  studentForm: FormGroup;
  stages: any;
  stagesListSubs: Subscription;
  types: any;
  typeListSubs: Subscription;
  private routeSub: Subscription;
  gradesListSubs: Subscription;
  grades: any;
  all: string;
  title: string;
  message: string;
  ok_txt: string;
  type: string;

  constructor(
    public dataService: DataService,
    private router: Router,
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    private translate: TranslateService,
    private snackbar: MatSnackBar
  ) { }

  public getType(schoolID: string, type: string) {

    this.typeListSubs = this.dataService
      .getTypes(schoolID, type)
      .subscribe(res => {
        this.types = res;

      },
        console.error
      );
  }

  public getStages(schoolID: string) {
    this.stages = [{ 'id': null, 'name': "" }]
    this.grades = [{ 'id': null, 'name': "" }]
    this.studentForm.controls["stages"].setValue('')
    this.studentForm.controls["grades"].setValue('')
    // this.studentForm.controls["lines"].setValue('')

    this.stagesListSubs = this.dataService
      .getStages(schoolID)
      .subscribe(res => {
        // 
        this.stages = res;
        this.translate.get('inputs.all').subscribe(res => {
          this.all = res;
        })
        this.stages = [{ 'id': 'all', 'name': this.all }].concat(this.stages)
        this.stages = [{ 'id': null, 'name': "" }].concat(this.stages)
        // this.studentForm.controls["stages"].setValue(res[0]['id'])
        // this.getGrades(res[0]['id'])
      },
        console.error
      );
  }

  public getGrades(stageID: string) {
    this.studentForm.controls["grades"].setValue('')
    if (stageID == 'all') {
      return false
    }

    var params = {}
    params['school_id'] = ''
    params['stage_id'] = stageID

    this.gradesListSubs = this.dataService
      .getGrades(params)
      .subscribe(res => {
        this.grades = res;
        this.translate.get('inputs.all').subscribe(res => {
          this.all = res;
        })
        this.grades = [{ 'id': 'all', 'name': this.all }].concat(this.grades)
        this.grades = [{ 'id': null, 'name': "" }].concat(this.grades)
        // this.studentForm.controls["grades"].setValue(res[0]['id'])
        // this.getLines(res[0]['id'])
      },
        console.error
      );
  }

  ngOnInit() {
    this.studentForm = this.formBuilder.group({
      id: new FormControl(0, Validators.required),
      stages: new FormControl('', Validators.required),
      grades: new FormControl('', Validators.required),
      type: new FormControl('', Validators.required),
    });

    this.dataService.getRole().subscribe(res => {
      if ((res != 'superadmin') && (res != 'admin')){
        this.router.navigate(['/welcome']);
      }

    });
    this.routeSub = this.route.params.subscribe(params => {
      if (params.id_school) {
        this.getType(params.id_school, 'school')
        this.getStages(params.id_school)
        this.type = 'school'
      }
      else if (params.id_reportage) {
        this.getType(params.id_reportage, 'reportage')
        this.type = 'reportage'
      }
      else if (params.id_school_orders) {
        this.getStages(params.id_school_orders)
        this.type = 'orders'
      }
    })
  }

  checkNotifications() {
    this.showPrimarySpinner = true;

    if (this.studentForm.controls["type"].value == '') {
      this.translate.get('alerts.type_required').subscribe(res => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        this.showPrimarySpinner = false;
      })
      return false

    }

    if (this.studentForm.controls["stages"].value == '' || this.studentForm.controls["stages"].value == null) {
      this.translate.get('alerts.stage_required').subscribe(res => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        this.showPrimarySpinner = false;
      })
      return false

    }

    if (this.studentForm.controls["stages"].value != 'all') {
      if (this.studentForm.controls["grades"].value == '' || this.studentForm.controls["grades"].value == null) {
        this.translate.get('alerts.grade_required').subscribe(res => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          this.showPrimarySpinner = false;
        })
        return false
      }
    }



    let params = {}
    this.routeSub = this.route.params.subscribe(r => {
      params['school_id'] = r.id_school
    })
    params['stage_id'] = this.studentForm.controls["stages"].value;
    params['grade_id'] = this.studentForm.controls["grades"].value;
    params['template_id'] = this.studentForm.controls["type"].value;
    params['type'] = 'school'



    this.translate.get('alerts.atention').subscribe(res => {
      this.title = res;
    })

    this.translate.get('alerts.checkNotifications').subscribe(res => {
      this.message = res;
    })

    this.translate.get('buttons.ok').subscribe(res => {
      this.ok_txt = res;
    })

    this.dataService.checkSendNotifications(params).subscribe(res => {
      // 
      params['users_list'] = JSON.stringify(res.user_list);
      
      this.showPrimarySpinner = false;
      this.message = this.message.replace('{{modify}}', res.num_emails)


      let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
        data: {
          message: this.message,
          title: this.title,
          ok_txt: this.ok_txt,
        }
      }).afterClosed().subscribe(res2 => {

        if (res2 === true) {
          this.showPrimarySpinner = true;
          
          this.dataService.sendNotifications(params).subscribe(res3 => {
            if (res3.status == 'ok') {
              this.translate.get('alerts.sendNotifications_ok').subscribe(res4 => {
                this.showPrimarySpinner = false;
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
              })
            }
            else {
              this.translate.get('alerts.send_notifications_error').subscribe(res4 => {
                this.showPrimarySpinner = false;
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000, panelClass: "error-snackbar" })
              })
            }
          })
        }


      })
    })
  }


  checkReportageNotifications() {
    this.showPrimarySpinner = true;

    if (this.studentForm.controls["type"].value == '') {
      this.translate.get('alerts.type_required').subscribe(res => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        this.showPrimarySpinner = false;
      })
      return false

    }



    let params = {}
    this.routeSub = this.route.params.subscribe(r => {
      params['reportage_id'] = r.id_reportage
    })
    params['template_id'] = this.studentForm.controls["type"].value;
    params['type'] = 'reportage'


    this.translate.get('alerts.atention').subscribe(res => {
      this.title = res;
    })

    this.translate.get('alerts.checkNotifications').subscribe(res => {
      this.message = res;
    })

    this.translate.get('buttons.ok').subscribe(res => {
      this.ok_txt = res;
    })

    this.dataService.checkSendNotifications(params).subscribe(res => {
      // 
      params['users_list'] = JSON.stringify(res.user_list);
      
      this.showPrimarySpinner = false;
      this.message = this.message.replace('{{modify}}', res.num_emails)


      let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
        data: {
          message: this.message,
          title: this.title,
          ok_txt: this.ok_txt,
        }
      }).afterClosed().subscribe(res2 => {

        if (res2 === true) {
          this.showPrimarySpinner = true;
          
          this.dataService.sendNotifications(params).subscribe(res3 => {
            if (res3.status == 'ok') {
              this.translate.get('alerts.sendNotifications_ok').subscribe(res4 => {
                this.showPrimarySpinner = false;
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
              })
            }
            else {
              this.translate.get('alerts.send_notifications_error').subscribe(res4 => {
                this.showPrimarySpinner = false;
                this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000, panelClass: "error-snackbar" })
              })
            }
          })
        }


      })
    })
  }



  processOrders() {
    this.showPrimarySpinner = true;

    if (this.studentForm.controls["stages"].value == '' || this.studentForm.controls["stages"].value == null) {
      this.translate.get('alerts.stage_required').subscribe(res => {
        this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
        this.showPrimarySpinner = false;
      })
      return false

    }

    if (this.studentForm.controls["stages"].value != 'all') {
      if (this.studentForm.controls["grades"].value == '' || this.studentForm.controls["grades"].value == null) {
        this.translate.get('alerts.grade_required').subscribe(res => {
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res, duration: 4000, panelClass: "error-snackbar" })
          this.showPrimarySpinner = false;
        })
        return false
      }
    }



    let params = {}
    this.routeSub = this.route.params.subscribe(r => {
      params['school_id'] = r.id_school_orders
    })
    params['stage_id'] = this.studentForm.controls["stages"].value;
    params['grade_id'] = this.studentForm.controls["grades"].value;
    params['type'] = 'orders'



    this.translate.get('alerts.atention').subscribe(res => {
      this.title = res;
    })

    this.translate.get('alerts.checkProcessOrders').subscribe(res => {
      this.message = res;
    })

    this.translate.get('buttons.ok').subscribe(res => {
      this.ok_txt = res;
    })

    this.dataService.checkProcessOrders(params).subscribe(res => {
      if (res.num_products == '0'){
        this.translate.get('alerts.any_product_to_process').subscribe(res4 => {
          this.showPrimarySpinner = false;
          this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
        })
      }
      else{
 
        params['products_list'] = JSON.stringify(res.products_list);
        
        this.showPrimarySpinner = false;
        this.message = this.message.replace('{{modify}}', res.num_products)


        let dialogRef = this.dialog.open(ConfirmReservationDialogComponent, {
          data: {
            message: this.message,
            title: this.title,
            ok_txt: this.ok_txt,
          }
        }).afterClosed().subscribe(res2 => {

          if (res2 === true) {
            this.showPrimarySpinner = true;
            
            this.dataService.processOrders(params).subscribe(res3 => {
              if (res3.status == 'ok') {
                this.translate.get('alerts.processOrders_ok').subscribe(res4 => {
                  this.showPrimarySpinner = false;
                  this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000 })
                })
              }
              else {
                this.translate.get('alerts.processOrders_error').subscribe(res4 => {
                  this.showPrimarySpinner = false;
                  this.snackbar.openFromComponent(CustomPopupComponent, { data: res4, duration: 4000, panelClass: "error-snackbar" })
                })
              }
            })
          }


        })
      }
    })
  }






}
